'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidPhoneLandscape = function IoAndroidPhoneLandscape(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35 28c0 1.8-1.5 3.3-3.2 3.3h-28.6c-1.7 0-3.2-1.5-3.2-3.3v-16c0-1.8 1.5-3.2 3.2-3.2h28.6c1.7 0 3.2 1.4 3.2 3.2v16z m-28.7 0.4h22.5v-16.8h-22.5v16.8z' })
        )
    );
};

exports.default = IoAndroidPhoneLandscape;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-phone-landscape.js
// module id = 1891
// module chunks = 0